import { ProductPublicModels } from '@features/products/product';
import { CategoryConfiguration, GridProductStyle } from '@shared/product/models';

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class StudioTemplatesService {
    public static mapTemplateConfiguration(
        resolution: string,
        catalogStyles: Record<string, string>,
        cmsStyles: Record<string, string>,
        templateSettings: any,
        place: string
    ): any {
        return {
            // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
            place: templateSettings?.hasOwnProperty('place') ? templateSettings?.place : place,
            // imageWidth: resolution === templateSettings.imageWidth.useMobileConfig
            //     ? templateSettings.imageWidth.mobile
            //     : templateSettings.imageWidth.desktop,
            showName: resolution === templateSettings.showName.useMobileConfig
                ? templateSettings.showName.mobile === 1
                : templateSettings.showName.desktop === 1, // ojo con resolution en SSR el servidor no conoce al cliente
            styles: {
                // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
                backgroundColor: templateSettings?.templateStyles?.hasOwnProperty('backgroundColor') ? templateSettings?.templateStyles?.backgroundColor : cmsStyles?.['background-color'] ?? catalogStyles?.backgroundColor,
                // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
                fontColor: templateSettings?.templateStyles?.hasOwnProperty('fontColor') ? templateSettings?.templateStyles?.fontColor : cmsStyles?.['font-color'] ?? catalogStyles?.fontColor,
                // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
                offerPrice: templateSettings?.templateStyles?.hasOwnProperty('offerPrice') ? templateSettings?.templateStyles?.offerPrice : cmsStyles?.['offer-price'] ?? catalogStyles?.offerPrice,
                // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
                colorSelector: templateSettings?.templateStyles?.hasOwnProperty('colorSelector') ? templateSettings?.templateStyles?.colorSelector : cmsStyles?.['color-selector'] ?? catalogStyles?.colorSelector,
                // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
                cardColor: templateSettings?.templateStyles?.hasOwnProperty('cardColor') ? templateSettings?.templateStyles?.cardColor : cmsStyles?.['background-color'] ?? catalogStyles?.backgroundColor,
            },
            ...templateSettings.templateConfiguration,
        };
    }

    public static setProductStyle(
        categoryConfiguration: CategoryConfiguration,
        products: ProductPublicModels.PublicProduct[]
    ): GridProductStyle {
        const categoryConfProduct = categoryConfiguration?.productConf?.get(+products[0]);
        return categoryConfProduct?.style;
    }
}
